import { createContext, useContext, useReducer } from 'react';

import ToastsContainer from '../../components/Toast/ToastContainer';
import { toastReducer } from '../../reducers';
import { IToastContext } from './ToastProvider.types';

export const ToastContext = createContext({} as IToastContext);

export const useToastContext = () => {
  const context = useContext(ToastContext);
  if (!context)
    throw new Error('useToastContext must be used within the ToastProvider');

  return context;
};

export const ToastProvider = ({ children }: { children: React.ReactNode }) => {
  const initialState = {
    toasts: [],
  };

  const [state, dispatch] = useReducer(toastReducer, initialState);

  const addToast = (type: string, message: string) => {
    const id = Math.floor(Math.random() * 10000000);
    dispatch({ type: 'ADD_TOAST', payload: { id, message, type } });
  };

  const remove = (id: number) => {
    dispatch({ type: 'DELETE_TOAST', payload: id });
  };

  const success = (message: string) => {
    addToast('success', message);
  };

  const warning = (message: string) => {
    addToast('warning', message);
  };

  const info = (message: string) => {
    addToast('info', message);
  };

  const error = (message: string) => {
    addToast('error', message);
  };

  const value = { success, warning, info, error, remove };

  return (
    <ToastContext.Provider value={value}>
      <ToastsContainer toasts={state.toasts} />
      {children}
    </ToastContext.Provider>
  );
};
